import Button from '@doordash/component-button'
import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { Bottom, Container } from './styles'
import { ANDROID_CLOSE_DEEPLINK, IOS_CLOSE_DEEPLINK } from '../../../constants'
import NavBar from '@doordash/component-navbar'

import { detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'
import t from './strings'
import * as DA from '../../../typeModules/events'

const os = detectWebviewOs()

type MailingAddressWelcomeKitProps = {
  track: (
    action: DA.EventActions,
    name: DA.AddressCollectionScreens
  ) => Promise<void>
}
export const MailingAddressWelcomeKit: React.FC<MailingAddressWelcomeKitProps> = ({
  track,
}) => {
  React.useEffect(() => {
    track(DA.EventActions.Rendered, DA.AddressCollectionScreens.Complete)
  }, [])

  return (
    <Container>
      <NavBar
        isSeparatorVisible={false}
        navigationType={NavBar.NavigationTypes.None}
      />
      <StackChildren>
        <Text styles={Text.Styles.PageTitle}>{t.welcomeKit.title()}</Text>
        <Text styles={Text.Styles.Medium16}>{t.welcomeKit.description()}</Text>
      </StackChildren>
      <Bottom>
        <Button
          onClick={() => {
            track(DA.EventActions.Close, DA.AddressCollectionScreens.Complete)
            window.location.assign(
              os === OsTypes.iOS ? IOS_CLOSE_DEEPLINK : ANDROID_CLOSE_DEEPLINK
            )
          }}
        >
          {t.welcomeKit.primaryAction()}
        </Button>
      </Bottom>
    </Container>
  )
}

export default MailingAddressWelcomeKit
